import type { Props } from './Label'
import Label from './Label'

const LabelPerFlag = (props: Props) => {
  return <Label {...props} />
}

export default LabelPerFlag
